
export function numbFormat (numb, precision = 0) {
  let multiplier = Math.pow(10, precision)
  let numbValue = (Math.round(numb * multiplier) / multiplier).toFixed(precision)

  let textValue = String(numbValue)
  if (numbValue === 0) {
    textValue = textValue.replace('-', '')
  }
  return textValue
}
